// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/museo-sans);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin:0;
  padding:0;
  height:100%;
  background: black !important;
}

.App {
  text-align: center;
  /* background: linear-gradient(#eb5757, #d59152);; */
  /* background: linear-gradient(rgba(177, 0, 99, 1)
  rgba(19, 75, 181, 1)
  ); */
  /* background: linear-gradient(#B10063, #134BB5, #210294, #210294); */
  background: linear-gradient(to right, rgba(177, 0, 99, 1), rgba(19, 75, 181, 1), rgba(33, 2, 148, 1));
  /* font-family: Museo Sans; */
  font-weight: 400;
  /* line-height: 48px; */
  font-size: 40px;
  color: white;
  min-height: 100%;
  position : relative;
}

.App-logo {
  /* height: 40vmin; */
  pointer-events: none;
  width: 300px;
}

input[type="radio"]:checked {
  background: black;
  border-color: white;
}

input[type="checkbox"]:checked {
  background-color: black;
  border-color: white;
}

.first-step-main-container {
  
  width: 45%;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-top: 1rem;
}

.all-evaluations-main-container {
  
  width: 65%;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-top: 1rem;
}

.my-account-main-container {
  
  width: 35%;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-top: 1rem;
}

.first-step-mobile-main-container {
  
  width: 85%;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-top: 1rem;
}

.second-step-main-container {
  
  width: 65%;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-top: 1rem;
}

.form-label {
  font-family: 'Montserrat';
  font-size: 16px;
  font-weight: 600;
  line-height: 19.5px;
  text-align: left;
  width: 100%;
}

.form-label-mobile {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  width: 100%;
}

/* @media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
} */

.App-header {
  /* background-color: #282c34; */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* font-size: calc(10px + 2vmin); */
  color: white;
}

.footer {
  height: 200px;
  background: black;
  bottom: 0;
  display: inline-block;
  width: 100%;
  /* position: absolute; */
  /* z-index: -1; */
}

.footer-text {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
}

.login-button {
  /* border-color: linear-gradient(rgba(177, 0, 99, 1), rgba(19, 75, 181, 1), rgba(33, 2, 148, 1)); */
  border-image: linear-gradient(to right, rgba(177, 0, 99, 1), rgba(19, 75, 181, 1), rgba(33, 2, 148, 1)) 30 !important;
  border-width: 2px !important;
  border-style: solid !important;
  border-image-slice: 1 !important;
  background: black !important;
  font-size: 18px !important; 
  font-weight: 600 !important; 
  padding: 16px 32px !important;
  /* font-family: 'Museo Sans' !important; */
}

.normal-button {
  border-image: linear-gradient(to right, rgba(177, 0, 99, 1), rgba(19, 75, 181, 1), rgba(33, 2, 148, 1)) 30 !important;
  border-width: 2px !important;
  border-style: solid !important;
  border-image-slice: 1 !important;
  background: black !important;
}

.note-text {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
}

.thead-font {
  font-family: 'Museo Sans';
  /* font-style: normal; */
  font-weight: 600;
  font-size: 15px;
  text-align: left;
  /* font-family: Museo Sans 700;
font-size: 15px;
font-weight: 600;
line-height: 20px;
letter-spacing: 0.4000000059604645px;
text-align: left; */

}

.tbody-font {
  font-weight: 400;
  text-align: left;
  font-family: 'Montserrat';
font-size: 14px;

}

.label-style {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600 !important;
  font-size: 1rem !important;
}


.accordion-button:not(.collapsed) {
  color: #1F1F1F  !important;
  background-color: #FFFFFF !important;
}

.accordion-button {
  color: #1F1F1F  !important;
  background-color: #FFFFFF !important;
  border: hidden !important;
  box-shadow: none !important;
  border-color: #FFF !important;
  font-family: museo-sans, sans-serif;
  font-size: 28px !important;
font-weight: 600 !important;
  /* padding-top: 0 !important;
  padding-bottom: 0 !important; */
}

.document-item {
  font-family: 'Museo Sans';
font-size: 28px !important;
font-weight: 600 !important;

text-align: center;

}

.flex-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  align-items: center;
}

.total-count-label {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 400;
  text-align: center;

}

.question-title {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.App-link {
  color: #61dafb;
}
@media only screen and (max-width: 1200px) {
  .App {background: linear-gradient(to bottom, rgba(177, 0, 99, 1), rgba(19, 75, 181, 1), rgba(33, 2, 148, 1));}
}
@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oDAAoD;EACpD;;MAEI;EACJ,qEAAqE;EACrE,qGAAqG;EACrG,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;GAIG;;AAEH;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mGAAmG;EACnG,qHAAqH;EACrH,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,qHAAqH;EACrH,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB;;;;;mBAKiB;;AAEnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B,eAAe;;AAEf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;AAC5B;;;AAGA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,mCAAmC;EACnC,0BAA0B;AAC5B,2BAA2B;EACzB;iCAC+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B,0BAA0B;AAC1B,2BAA2B;;AAE3B,kBAAkB;;AAElB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,MAAM,sGAAsG,CAAC;AAC/G;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Montserrat');\n@import url('https://fonts.cdnfonts.com/css/museo-sans');\nhtml, body {\n  margin:0;\n  padding:0;\n  height:100%;\n  background: black !important;\n}\n\n.App {\n  text-align: center;\n  /* background: linear-gradient(#eb5757, #d59152);; */\n  /* background: linear-gradient(rgba(177, 0, 99, 1)\n  rgba(19, 75, 181, 1)\n  ); */\n  /* background: linear-gradient(#B10063, #134BB5, #210294, #210294); */\n  background: linear-gradient(to right, rgba(177, 0, 99, 1), rgba(19, 75, 181, 1), rgba(33, 2, 148, 1));\n  /* font-family: Museo Sans; */\n  font-weight: 400;\n  /* line-height: 48px; */\n  font-size: 40px;\n  color: white;\n  min-height: 100%;\n  position : relative;\n}\n\n.App-logo {\n  /* height: 40vmin; */\n  pointer-events: none;\n  width: 300px;\n}\n\ninput[type=\"radio\"]:checked {\n  background: black;\n  border-color: white;\n}\n\ninput[type=\"checkbox\"]:checked {\n  background-color: black;\n  border-color: white;\n}\n\n.first-step-main-container {\n  \n  width: 45%;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  margin-top: 1rem;\n}\n\n.all-evaluations-main-container {\n  \n  width: 65%;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  margin-top: 1rem;\n}\n\n.my-account-main-container {\n  \n  width: 35%;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  margin-top: 1rem;\n}\n\n.first-step-mobile-main-container {\n  \n  width: 85%;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  margin-top: 1rem;\n}\n\n.second-step-main-container {\n  \n  width: 65%;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  margin-top: 1rem;\n}\n\n.form-label {\n  font-family: 'Montserrat';\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 19.5px;\n  text-align: left;\n  width: 100%;\n}\n\n.form-label-mobile {\n  font-family: 'Montserrat';\n  font-size: 14px;\n  font-weight: 600;\n  text-align: left;\n  width: 100%;\n}\n\n/* @media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n} */\n\n.App-header {\n  /* background-color: #282c34; */\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  /* font-size: calc(10px + 2vmin); */\n  color: white;\n}\n\n.footer {\n  height: 200px;\n  background: black;\n  bottom: 0;\n  display: inline-block;\n  width: 100%;\n  /* position: absolute; */\n  /* z-index: -1; */\n}\n\n.footer-text {\n  font-family: 'Montserrat';\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 17.07px;\n  text-align: left;\n}\n\n.login-button {\n  /* border-color: linear-gradient(rgba(177, 0, 99, 1), rgba(19, 75, 181, 1), rgba(33, 2, 148, 1)); */\n  border-image: linear-gradient(to right, rgba(177, 0, 99, 1), rgba(19, 75, 181, 1), rgba(33, 2, 148, 1)) 30 !important;\n  border-width: 2px !important;\n  border-style: solid !important;\n  border-image-slice: 1 !important;\n  background: black !important;\n  font-size: 18px !important; \n  font-weight: 600 !important; \n  padding: 16px 32px !important;\n  /* font-family: 'Museo Sans' !important; */\n}\n\n.normal-button {\n  border-image: linear-gradient(to right, rgba(177, 0, 99, 1), rgba(19, 75, 181, 1), rgba(33, 2, 148, 1)) 30 !important;\n  border-width: 2px !important;\n  border-style: solid !important;\n  border-image-slice: 1 !important;\n  background: black !important;\n}\n\n.note-text {\n  font-family: Montserrat;\n  font-size: 12px;\n  font-weight: 400;\n  text-align: left;\n}\n\n.thead-font {\n  font-family: 'Museo Sans';\n  /* font-style: normal; */\n  font-weight: 600;\n  font-size: 15px;\n  text-align: left;\n  /* font-family: Museo Sans 700;\nfont-size: 15px;\nfont-weight: 600;\nline-height: 20px;\nletter-spacing: 0.4000000059604645px;\ntext-align: left; */\n\n}\n\n.tbody-font {\n  font-weight: 400;\n  text-align: left;\n  font-family: 'Montserrat';\nfont-size: 14px;\n\n}\n\n.label-style {\n  font-family: 'Raleway';\n  font-style: normal;\n  font-weight: 600 !important;\n  font-size: 1rem !important;\n}\n\n\n.accordion-button:not(.collapsed) {\n  color: #1F1F1F  !important;\n  background-color: #FFFFFF !important;\n}\n\n.accordion-button {\n  color: #1F1F1F  !important;\n  background-color: #FFFFFF !important;\n  border: hidden !important;\n  box-shadow: none !important;\n  border-color: #FFF !important;\n  font-family: museo-sans, sans-serif;\n  font-size: 28px !important;\nfont-weight: 600 !important;\n  /* padding-top: 0 !important;\n  padding-bottom: 0 !important; */\n}\n\n.document-item {\n  font-family: 'Museo Sans';\nfont-size: 28px !important;\nfont-weight: 600 !important;\n\ntext-align: center;\n\n}\n\n.flex-center {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.total-count-label {\n  font-family: 'Montserrat';\n  font-size: 14px;\n  font-weight: 400;\n  text-align: center;\n\n}\n\n.question-title {\n  font-family: 'Montserrat';\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.App-link {\n  color: #61dafb;\n}\n@media only screen and (max-width: 1200px) {\n  .App {background: linear-gradient(to bottom, rgba(177, 0, 99, 1), rgba(19, 75, 181, 1), rgba(33, 2, 148, 1));}\n}\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
